var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 15.0237V17.6423H4.61779L11.7855 9.91918L9.35522 7.30059L2.1875 15.0237ZM13.6649 7.89414C13.9177 7.6218 13.9177 7.18188 13.6649 6.90954L12.1484 5.27554C11.8957 5.00321 11.4874 5.00321 11.2346 5.27554L10.0487 6.55341L12.4789 9.17201L13.6649 7.89414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditableIcon);
export default __webpack_public_path__ + "static/media/editable-icon.77b882a6cd358f1f689d20679a310ee7.svg";
export { ForwardRef as ReactComponent };